import React, { useEffect } from "react";
import {
  Container,
  Grid,
  Box,
  Paper,
  Card,
  CardMedia,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemButton,
  ListSubheader,
} from "@mui/material";

import {
  Image as ImageIcon,
  Work as WorkIcon,
  BeachAccess as BeachAccessIcon,
  AccountCircle,
  Portrait,
  MarkEmailRead,
  ContactPhone,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { getDev } from "../../features/Dev/devSlice";

const MenuList = () => {
  // const { user } = useSelector((state) => state.auth);
  const { dev } = useSelector((state) => state.dev);

  const { firstName, lastName, name, email, phone, photo_url } = dev;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDev());
  }, []);

  return (
    <>
      <Container maxWidth>
        <Box>
          <Box>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                <ListSubheader component="div" id="nested-list-subheader">
                  Your Profile
                </ListSubheader>
              }
            >
              <ListItem
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  float: "center",
                }}
              >
                <ListItemAvatar>
                  <Avatar
                    alt="Remy Sharp"
                    src={photo_url}
                    sx={{ width: 80, height: 80 }}
                  />
                </ListItemAvatar>
              </ListItem>
              <ListItem>
                <ListItemButton component="button">
                  <ListItemAvatar>
                    <Avatar>
                      <AccountCircle
                      // sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="First Name" secondary={firstName} />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton component="button">
                  <ListItemAvatar>
                    <Avatar>
                      <AccountCircle />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Last Name" secondary={lastName} />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton component="button">
                  <ListItemAvatar>
                    <Avatar>
                      <Portrait />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="User Name" secondary={name} />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton>
                  <ListItemAvatar>
                    <Avatar>
                      <MarkEmailRead />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Email" secondary={email} />
                </ListItemButton>
              </ListItem>
              <ListItem>
                <ListItemButton>
                  <ListItemAvatar>
                    <Avatar>
                      <ContactPhone />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary="Phone" secondary={phone} />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default MenuList;
